import Vue from 'vue';
import Component from 'vue-class-component';
import {AuthorisationManager, Identity, Icon} from 'wc-lib';
import {Prop} from 'vue-property-decorator';
import {Service} from '../service';
import {MenuItem} from '../model/menu-item';
import {Links} from './links';

require('../../icons/plus.svg');
require('../../icons/minus.svg');

@Component({
  template: require('./menu-item.html'),
  components: {
    'wc-icon': Icon,
    'links': Links
  }
})
export class MenuItemComponent extends Vue {
  @Prop()
  item: MenuItem;

  @Prop()
  level: number;

  get levelClass() {
    return `level-${this.level}`;
  }

  subMenuItemClick(item: MenuItem) {
    item.isActive = !item.isActive;
  }
}



// WEBPACK FOOTER //
// src/components/menu-item.ts